import { Download } from 'lucide-react'
import { timeAgo } from '../../lib/timeAgo.js'

const KIND_LABELS = { cre: 'Compte-rendu (CRE)', client_summary: 'Synthèse client', internal_notes: 'Notes internes' }

export default function ArchivesSection({ archives, downloadURLFor }) {
  if (!archives || archives.length === 0) return null
  return (
    <section className="mt-8">
      <h2 className="mb-3 text-[14px] font-medium">Archives</h2>
      <ul className="space-y-2">
        {archives.map((a) => (
          <li
            key={a.ID || a.id}
            className="flex items-center justify-between rounded-xl border border-line bg-white px-4 py-3"
          >
            <div>
              <div className="text-[13.5px] font-medium">{KIND_LABELS[a.Kind || a.kind] || (a.Kind || a.kind)}</div>
              <div className="text-[11.5px] text-muted">{timeAgo(a.CreatedAt || a.created_at)}</div>
            </div>
            <a
              href={downloadURLFor(a.ID || a.id)}
              download
              className="flex items-center gap-1.5 rounded-lg border border-line bg-bg px-3 py-1.5 text-[12px] text-ink hover:border-terra-500"
            >
              <Download size={13} /> Télécharger
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
